module.exports = __webpack_public_path__ + "static/img/special-day-tablet.a88226c.svg";